"use client"

import { FieldItem, FieldOfActivityProps } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/FieldOfActivity"
import { FieldActivityItem } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/FieldOfActivity/components/FieldActivityItem"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { generateResponsiveCSS } from "../../../lib/helper"

export const RenderConfig: ComponentConfig<FieldOfActivityProps> = {
  render: ({ className, styles, responsiveType, fields }) => {
    const id = `tamda-group-services-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div className={twMerge(className)} id={id}>
          <div className="container mx-auto max-w-[1290px] px-[15px]">
            <div className="flex flex-col gap-1 w-full">
              {fields && fields.length > 0 && (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 sm:gap-1 gap-2">
                    {fields.slice(0, 2).map((field: FieldItem, index: number) => (
                      <FieldActivityItem key={index} field={field} index={index} />
                    ))}
                  </div>

                  {fields.length > 2 && (
                    <div className="grid grid-cols-1 md:grid-cols-3 sm:gap-1 gap-2">
                      {fields.slice(2).map((field: FieldItem, index: number) => (
                        <FieldActivityItem key={index + 2} field={field} index={index + 2} />
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </>
    )
  },
}

export default RenderConfig
